module.exports = __webpack_public_path__ + "img/solution.9d03ba81.png";